export default __webpack_public_path__ + "static/media/LOGO.b116fb9e.png";